import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { redirectToLogin } from './api';

const LoginSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loginError, setLoginError] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token  = params.get('token');

    if (token) {
      localStorage.setItem('authToken', token);
      const dishName = params.get('dishName') || sessionStorage.getItem('pendingRecipeDish');
      if (dishName) {
        sessionStorage.setItem('pendingRecipeDish', dishName);
      }
      const returnTo = sessionStorage.getItem('authReturnTo');
      sessionStorage.removeItem('authReturnTo');
      const destination = dishName
        ? '/dish'
        : returnTo && returnTo.startsWith('/') && !returnTo.startsWith('//')
          ? returnTo
          : '/diet';
      navigate(destination, { replace: true });
    } else if (params.get('dishName')) {
      sessionStorage.setItem('pendingRecipeDish', params.get('dishName'));
      redirectToLogin('/dish');
    } else if (params.get('error') === 'oauth2') {
      setLoginError(true);
    } else {
      // Auth failed or was cancelled — go home silently.
      navigate('/', { replace: true });
    }
  }, [location.search, navigate]);

  if (loginError) {
    return (
      <main style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        gap: '16px',
        textAlign: 'center',
      }}>
        <p role="alert">Google sign-in failed. Please try again.</p>
        <button type="button" onClick={redirectToLogin}>Try again</button>
      </main>
    );
  }

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      fontFamily: "'DM Sans', sans-serif",
      gap: '16px',
    }}>
      <div style={{
        width: '40px',
        height: '40px',
        border: '3px solid var(--color-border)',
        borderTopColor: 'var(--color-secondary)',
        borderRadius: '50%',
        animation: 'spin 0.9s linear infinite',
      }} />
      <p style={{ color: 'var(--color-text-muted)', fontSize: '0.95rem', margin: 0 }}>
        Finalising login…
      </p>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
};

export default LoginSuccess;
